import { render, staticRenderFns } from "./TuitionFeeClassSetup.vue?vue&type=template&id=425dfdfb"
import script from "./TuitionFeeClassSetup.vue?vue&type=script&lang=js"
export * from "./TuitionFeeClassSetup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports